import { useState, useEffect } from "react";
import Config from "../../Config";

import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";


import InputUploader from "../../helpers/InputUploader";

import icoDotted from "../../dotted.png";


function WallPublishEdit(props)
{



    var startRow = {
        id: props.row.id,
        opis: props.row.opis,
        kolor: props.row.kolor,
        grupy: props.row.grupy,
        t_p: props.row.widoczne_dla_pracownikow,
        t_r: props.row.widoczne_dla_rodzicow,
        komentarze: props.row.mozna_komentowac,
        crypt: 'wall_' + Math.floor(Math.random() * 100000000) + "_"+Date.now()+"_"+props.userData.p_przedszkole_id+"_"+Math.floor(Math.random() * 100000000) ,
    };

    if(startRow.komentarze.length == 0) startRow.komentarze = '0';



    const [view, setView] = useState('inline');  //dialog
    const [row,setRow] = useState(startRow);


    const [loaded, setLoaded] = useState(0);

    const [plgr, setPlGr] = useState( {
        result: []
    });

    const [files, setFiles] = useState([]);
    const [fileMerge, setFileMerge] = useState('');
    const [viewFiles, setViewFiles] = useState('merge'); //list


    var startCls = '';
    if(startRow.kolor == '#FF0000'  )  startCls = 'pred';
    if(startRow.kolor == '#FFFFFF'  )  startCls = 'pwhite';
    if(startRow.kolor == '#00AA00'  )  startCls = 'pgreen';
    if(startRow.kolor == '#AF4C12'  )  startCls = 'pbro';
    if(startRow.kolor == '#9712AF'  )  startCls = 'pfiol';
    if(startRow.kolor == '#126aaf'  )  startCls = 'pblue';
    if(startRow.kolor == '#74af12'  )  startCls = 'pgrx';
    if(startRow.kolor == '#af3d12'  )  startCls = 'porange';

    const [cls, setCls] = useState(startCls);


    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    


    const changeFilesView = ()  => {

        if(viewFiles == 'merge')
        {
            setViewFiles('list');
        }else setViewFiles('merge');

    }

    const changeView = () => {
        if(view == 'inline')
        {
            setView('dlg');
        }else setView('inline');

     
    }


    const setClsStyle = (e) => {

        var s = e.target.getAttribute("cls");
        var col = e.target.getAttribute("col");


        setCls(s);
        setRow( {...row, ['kolor']:col,  ["kolor_valid"]:true } );         
    }


    const valChangeListener = (filedName, val, correct, msg) => {
 

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        
 

        var tabCheck = filedName.split('@');
        if(tabCheck.length == 2)
        {
            var tabName = tabCheck[0];
            var tabInx  = tabCheck[1];

            if(tabName == 'grupy')
            {
                console.log("grupy", row.grupy);
                //console.log("plg", plgr.result);

                //sprawdzy czy klikniete id wystepuje w grupach,, tzn czy jest zaznaczone
                var isChecked = false;
                var newListGrupWithoutSelected = new Array();

                for(var kx=0; kx < row.grupy.length; kx++)
                {
                    if( parseInt( row.grupy[kx]) == parseInt(val) ) { isChecked =true; continue; }

                    newListGrupWithoutSelected.push(  "" + row.grupy[kx] + "" ); //wypełnij bez grupy znalezionej..
                }

                if(isChecked) //wybran więc trzeba ją usunąć z listy..
                {
                    console.log("grupa wybrana,", val);                    
                    setRow( {...row, [tabName]:newListGrupWithoutSelected } );   
                    return;
                }else
                {
                    console.log("grupa nie wybrana,", val); 
                    newListGrupWithoutSelected.push( "" + val + "" );                   
                    setRow( {...row, [tabName]:newListGrupWithoutSelected } );   
                    return;
                }


                return;
            }


            var tRef = row[tabName];
            if(correct)tRef[tabInx] = val;
            if(!correct)tRef[tabInx] = ""; 
            setRow( {...row, [tabName]:tRef } );   
            return;
        }


        


        if(msg == "checked")
        {
             setRow( {...row, [filedName]:"1",  [filedName+"_valid"]:correct } );         
             return;
        }

        if(msg == "unchecked")
        {
             setRow( {...row, [filedName]:"0",  [filedName+"_valid"]:correct } );         
             return;
        }



        if(correct)
        {
          setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
        }else   setRow( {...row, [filedName]:'',  [filedName+"_valid"]:correct } );  
    } 


    const valChange = (filedName, val, correct, msg) => {

        //  console.log(filedName + " " + val);
        
          setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
      }
  
      const goNext = () => {
          console.log("goNext");
      }




      const getDataPlGr = () => {
       
 
        var req = {
        
        };

        fetch( Config.url + '/rest_v1,places_groups', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    setPlGr(res); 
 
                 
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }


    const reloadFiles = () => {
       
 
        var req = {
            typ: 'p_wydarzenia',
            typ_id: startRow.id,
            crypt: "",
            thumb: 1,
            merge: 1,
        };

        fetch( Config.url + '/rest_v1,get_by', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    setFiles(res.result.list); 

                    setFileMerge(res.result.merge);
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }



    const completeUpload = (fileName, crypt) => {

        console.log("completeUpload " + fileName + " " + crypt);
        reloadFiles();
        setViewFiles('merge');
 
    }



    const delFile = (e) => {
       
        var idx = e.target.getAttribute('id');
 
        e.target.innerHTML ="...";

        var req = {
            crypt: '',
            typ: 'p_wydarzenia',
            typ_id: row.id,
            id: idx,
        };


        fetch( Config.master + '/rest_v1,del_by', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                     reloadFiles();
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }


 

    if(loaded == 0 && view != 'inline')
    {   
        setLoaded(1);
        getDataPlGr();
        reloadFiles();
        return <div></div>      
    }


    


    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    const publish = (e) => {


        props.mainView.setProgress(-2);
 
      //  if(!valChecker(row))
       // {
          //  props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
         //   return;
       // }
   

        if(row.opis.length < 1)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Podaj treść"  ,  "ok"  ,null); 
            return;
        }


        if( (row.t_p == '' || row.t_p == '0') && (row.t_r == '' || row.t_r == '0') )
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz grupę odbiorców (pracowników, rodziców)"  ,  "ok"  ,null); 
            return;
        }

        //sprawdz czy zaznaczona grupe..
        var gc = false;
        for(var k=0; k<row.grupy.length; k++)
        {
            if(row.grupy[k] != '') gc = true;
        }


        if( gc == false )
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz min. jedną grupę przedszkolną"  ,  "ok"  ,null); 
            return;
        }

        

       // alert(JSON.stringify(row) );
        e.target.innerHTML = "...";
        

        
        var req = {
        
        };

        req = row;
        if(req.t_r == '') req.t_r = '0';
        if(req.t_p == '') req.t_p = '0';
        if(req.komentarze == '') req.komentarze = '0';

        fetch( Config.master + '/rest_v1_news,publish_edit', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {         

                                       
                  // setRow(startRow);
                   changeView();
                   props.mainView.setProgress(-1); 
                   props.refresh();                   


         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });



    }






    var rawFiles = null;


    if( files != null &&  files.length > 0)
    {
        rawFiles = <div>
                    <br/>
                  {
                        files.map( (ff, ix ) => {

                            if(ff.typ_pliku == 'jpg' || ff.typ_pliku == 'png' || ff.typ_pliku == 'jpeg' || ff.typ_pliku == "bmp") return null;

                            return <span>
                                {ff.nazwa} <sup className="link_color" id={ff.id} onClick={delFile}  >usuń</sup>
                            </span>
                        } )
                  }
                  <br/>&nbsp;
        </div>
    }

    
 
    var mergeX =  <div className="img_empty"> </div>;
    if(fileMerge.length > 10)
    {
            mergeX = <div className="images_sc" onClick={changeFilesView}  >
                    <img className="pimg_x" src={ "data:image/jpeg;base64, " + fileMerge }  onClick={changeFilesView}  />
            </div>
    }



    var list =      <div className="images_sc">
                        <span onClick={changeFilesView} className="link_color"> pokaż podgląd</span>
                        <br/><br/>
                    {
                        files.map( (item, ix) => {

                            return (
                      
                                        
                                        <div className="img_option">
                                            <span className="link_color" id={item.id} onClick={delFile} >usuń</span>
                                             <img className="pimg_x" src={ "data:image/jpeg;base64, " + item.b64 } />
                                        </div>  
                             
                                                                            
                            )

                        } )
                    }
                </div>


    var selectedView = null;
    if(viewFiles == 'merge') selectedView = mergeX;
    if(viewFiles == 'list') selectedView = list;


    var nazwaPlacowki = "";

    for(var px =0; px<props.userData.pl.length; px++)
    {
        if(props.userData.pl[px].id  == props.userData.p_przedszkole_id )
        {
            nazwaPlacowki = props.userData.pl[px].nazwa;
        }
    }


    var dlg = <div className="publish_dlg">
                    <div className="pwindow shadowx">

                      

                        <form className="eForm bg_center">
                            

                                <div className="ptxt">
                                    <InputTextArea   cls={cls}  value={row.opis} valChange={valChange} goNext={goNext} name="opis" placeholder={  "Co słychać? "} className='  ' req='0' /> 
                                    <div className="pcolors">
                                        <div className=" pcitem pwhite" cls="pwhite" col="#FFFFFF" onClick={setClsStyle} ></div>
                                        <div className=" pcitem pred"   cls="pred" col="#FF0000" onClick={setClsStyle}></div>
                                        <div className=" pcitem pgreen" cls="pgreen" col="#00AA00" onClick={setClsStyle}></div>
                                        <div className=" pcitem pbro" cls="pbro" col="#AF4C12" onClick={setClsStyle}></div>
                                        <div className=" pcitem pfiol" cls="pfiol" col="#9712AF" onClick={setClsStyle}></div>
                                        <div className=" pcitem pblue" cls="pblue" col="#126aaf" onClick={setClsStyle}></div>
                                        <div className=" pcitem pgrx" cls="pgrx" col="#74af12" onClick={setClsStyle}></div>
                                        <div className=" pcitem porange" cls="porange" col="#af3d12" onClick={setClsStyle}></div>  
                                    </div>
                                </div>
                    
                                <div className="gtypes">                                  
                                    <div>
                                            <div className="form_control">                                                         
                                                    <InputChecbox  title="Dla pracowników"  err={errTab}  userData={props.userData}  checked={row.t_p} value={"1"} valChange={valChangeListener}  name={ "t_p"  }   className=' ' req='0' />
                                            </div>                                    
                                            
                                            <div className="form_control">                                                         
                                                    <InputChecbox  title="Dla rodziców"  err={errTab}  userData={props.userData}  checked={row.t_r} value={"1"} valChange={valChangeListener}  name={ "t_r"  }   className=' ' req='0' />
                                            </div> 

                                            <div className="form_control">                                                         
                                                    <InputChecbox  title="Można komentować"  err={errTab}  userData={props.userData}  checked={row.komentarze} value={"1"} valChange={valChangeListener}  name={ "komentarze"  }   className=' ' req='0' />
                                            </div> 
                                    </div>                                          
                                </div>


                               

                                <div className="gtypes">
                                <b>Widoczne dla odbiorców powiązanych z grupami: </b>
                            
                                  
                                {
                                                    plgr.result.map( (item, ix) => {  

                                                            return (
                                                                <div>
                                                                    { 
                                                                           item.grupy.map(  (gr, ixpl) => {


                                                                            if(item.id != props.userData.p_przedszkole_id)
                                                                            {
                                                                                   return null;
                                                                            }

                                                                            var cc = false;

                                                                            for(var mm =0; mm<row.grupy.length; mm++)
                                                                            {
                                                                                if(row.grupy[mm] == gr.id) cc = true;
                                                                            }

                                                                             

                                                                            return (
                                                                                <div className="form_control">                                                         
                                                                                    <InputChecbox  title={gr.nazwa}  err={errTab}  userData={props.userData}  checked={cc} value={ gr.id } valChange={valChangeListener}  name={ "grupy@"+ixpl  }   className=' ' req='0' />
                                                                                </div> 
                                                                            )
                
                
                                                                            } )
                                                                    }
                                                                </div>
                                                            )                                                             

                                                      } )
                                            }
                              
                                          
                                </div>

 

                                <div className="gtypes">
                                     
                                        <sup className="link_color">
                                                <InputUploader   userData={props.userData}  typ="p_wydarzenia" typId={row.id} remove="0" crypt="" completeUpload={completeUpload} title="dodaj zdjęcie / pliki" max_files="100" ext="image/png, image/jpeg, video/*" />                               
                                        </sup> 
                                 
                                        {rawFiles}
                                        {selectedView}
  

                                </div>

                                <div className="gbtns">
                                                <span className="btn" onClick={publish}>Aktualizuj</span>
                                                &nbsp;&nbsp;
                                                <span className="btn" onClick={changeView}>Anuluj</span>
                                </div>
                        </form>
                    </div>
    </div>

    if(view == 'inline') dlg = null;



 //   console.log("ROW " + JSON.stringify(row) );


    return (
        <span>
              
                 <img src={icoDotted}  className="link_normal" onClick={changeView}  />
                 {dlg} 
        </span>              
    )

   
}


export default WallPublishEdit;